import { createStateHook, createNextHook } from '@restate/core'
import { AppStoreProvider } from 'state/store'

export const useInstituteAdminSharesState = createStateHook(
  AppStoreProvider,
  state => state.pages.instituteAdminShares
)
export const useNextInstituteAdminSharesState = () =>
  createNextHook(AppStoreProvider, state => state.pages.instituteAdminShares)
